import React from 'react';
import { connect } from 'dva';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { Button, Checkbox, Input, Modal, Popconfirm, Popover, Select, Table, Tree } from 'antd';
import checkedImg from '../../assets/circle-ok.png';
import uncheckedImg from '../../assets/circle-o.png';
import userImg from '../../assets/user-icon.svg';
import IconTip from '../../components/IconTip';
import { ATTEND_MODAL, ENGLISH, HOLDER_MODAL, VIDEO_PUBLIC_MODAL } from '../../utils/constants';

let timeoutId = 0;
const TreeNode = Tree.TreeNode;
const Option = Select.Option;

class UserSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      btnAble: true,
      holder: {},
      selectedList: [],
      allChecked: false,
      selectedNode: '',
      searchValue: {},
      pageSize: 20,
      pageCurrent: 1,
      showModal: false,
      tempUser: {}
    };
  }

  componentWillMount() {
    const {intl, dispatch, selected, holder} = this.props;
    this.locale = intl.formatMessage({id: 'locale'});
    dispatch({type: 'account/findDeptTree'});
    if (!_.isEmpty(selected)) this.constructSelectedList(selected);
    if (!_.isEmpty(holder)) this.constructHolder(holder);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.userByDept &&
      nextProps.userByDept && !_.isEqual(this.props.userByDept.rows, nextProps.userByDept.rows)
    ) {
      this.isAllChecked(nextProps.userByDept.rows, this.state.selectedList);
    }
    if (!_.isEqual(this.props.selected, nextProps.selected)) {
      this.constructSelectedList(nextProps.selected);
    }
    if (!_.isEqual(this.props.holder, nextProps.holder)) {
      this.constructHolder(nextProps.holder);
    }
  }

  render() {
    const {
      intl,
      dispatch,
      allDeptData,
      modalType,
      inviteFlag = 0
    } = this.props;
    const {
      selectedList,
      holder,
      selectedNode,
      searchValue,
      pageSize
    } = this.state;
    const {textValue = ''} = searchValue;
    const userByDept =
      selectedNode || !this.isSearchValueEmpty(searchValue)
        ? this.props.userByDept
        : [];
    let allChecked = this.getAllCheckedState(
      userByDept ? userByDept.rows : null,
      selectedList
    );
    this.locale = intl.formatMessage({id: 'locale'});
    let holderModal = modalType === HOLDER_MODAL;
    let attendModal = modalType === ATTEND_MODAL;
    let videoModal = modalType === VIDEO_PUBLIC_MODAL;
    const tableData = holderModal
      ? holder.userId
      ? [holder]
      : []
      : selectedList;

    const columns = [
      {
        title: intl.formatMessage({id: 'index_username'}),
        key: 'userName',
        className: 'user-name-col',
        render: record => {
          if (record.selectType == 0) {
            return (
              <span className="meeting-inner-attend">{record.userName}</span>
            );
          } else {
            return (
              <span className="meeting-outer-attend">{record.userName}</span>
            );
          }
        }
      },
      {
        title: intl.formatMessage({id: 'tel'}),
        key: 'mobile',
        render: record => {
          let mobile =  record.mobile || '';
          let telAreaCode =  record.telAreaCode || '';
          if (record.selectType == 0 || !telAreaCode || !mobile || mobile.indexOf('+') == 0) {
            return <span className="meeting-outer-attend">{mobile}</span>;
          } else {
            return <span className="meeting-outer-attend">{telAreaCode + mobile}</span>;
          }
        }
      },
      {
        title: intl.formatMessage({id: 'index_email'}),
        key: 'email',
        render: record => {
          return <span className="meeting-outer-attend">{record.email}</span>;
        }
      },

      {
        title: intl.formatMessage({id: 'main_meeting_type'}),
        key: 'selectType',
        render: record => {
          if (record.selectType == 0) {
            return (
              <span className="meeting-inner-attend">
                {videoModal ? '内部联系人' : intl.formatMessage({id: 'meeting_attends_inner'})}
              </span>
            );
          } else {
            return (
              <span className="meeting-outer-attend">
                {videoModal ? '外部联系人' : intl.formatMessage({id: 'meeting_attends_outer'})}
              </span>
            );
          }
        }
      }
    ];

    if (1 == inviteFlag) {
      columns.push({
        title: intl.formatMessage({id: 'meeting_book_column_invite'}),
        key: 'invite',
        render: record => {
          if (record.selectType == 1) {
            return (
              <Checkbox
                checked={record.invite}
                onChange={e => {
                  tableData.map(item => {
                    if (item.userId == record.userId) {
                      item.invite = e.target.checked;
                    }
                  });
                  if (holderModal) {
                    this.setState({
                      holder: tableData.length > 0 ? tableData[0] : []
                    });
                  } else {
                    this.setState({selectedList: selectedList});
                  }
                }}
              />
            );
          }
        }
      });
    }
    columns.push({
      title: intl.formatMessage({id: 'mc_table_option'}),
      key: 'operate',
      render: record => {
        return (
          <span
            className="meeting-attend-del"
            onClick={() => {
              if (holderModal) {
                this.setState({holder: {}});
              } else {
                let index = -1;
                selectedList.map((item, i) => {
                  if (String(item.userId) === String(record.userId)) index = i;
                });
                let userList = _.cloneDeep(selectedList);
                if (index >= 0) {
                  userList.splice(index, 1);
                }
                this.setState({selectedList: userList});
              }
            }}
          >
            <IconTip title="删除" type="shanchu"/>
          </span>
        );
      }
    });
    return (
      <div className="modal-user-select">
        <div id="show-more" className="show-more">
          <div className="meeting-cont">
            <div className="meeting-mesage">
              <p className="state">
                {holderModal && <FormattedMessage id='add_holder'/>}
                {attendModal && <FormattedMessage id='add_attend'/>}
              </p>
            </div>
            {/*<div className="cover"/>*/}
            <i
              className="iconfont icon-x"
              onClick={() => this.cancelSubmit()}
            />
          </div>
          <div className="attend-select">
            <div className="attend-select-flex">
              <div className="attend-select-tree">
                <div className="search-item">
                  <label>
                    <FormattedMessage id="index_username"/>
                    &nbsp;:
                  </label>
                  <span className="search-input">
                    <Input
                      autoFocus
                      value={textValue}
                      className="search-input-comp"
                      onChange={e => {
                        let content = e.target.value;
                        searchValue.textValue = content;
                        this.setState({
                          searchValue: searchValue,
                          pageCurrent: 1
                        });
                        if (!this.isSearchValueEmpty(searchValue)) {
                          clearTimeout(timeoutId);
                          timeoutId = setTimeout(() => {
                            const {
                              textValue = '',
                              positionValue = ''
                            } = searchValue;
                            let payload = {
                              term: textValue,
                              position: positionValue,
                              page: 1,
                              rows: pageSize
                            };
                            dispatch({
                              type: 'meeting/findUsersBySearch',
                              payload: payload
                            });
                          }, 1000);
                        } else {
                          dispatch({
                            type: 'meeting/setUsersByDept',
                            userByDept: {}
                          });
                        }
                      }}
                    />
                  </span>
                </div>
                <Tree
                  defaultExpandedKeys={[
                    String(allDeptData ? allDeptData.nodeCode : '')
                  ]}
                  onSelect={(selectedKeys, e) => {
                    let node = selectedKeys ? selectedKeys[0] : '';
                    let payload = {nodeCode: node, page: 1, rows: pageSize};
                    dispatch({
                      type: 'meeting/findUsersByDept',
                      payload: payload
                    });
                    this.setState({
                      selectedNode: node,
                      searchValue: {},
                      pageCurrent: 1
                    });
                  }}
                >
                  <TreeNode
                    key={-2}
                    value={String(-2)}
                    className="tree-node-user"
                    title={
                      <span>
                        <img src={userImg} className="tree-node-icon"/>
                        <span className="tree-node-text">常用联系人</span>
                      </span>
                    }
                  />
                  <TreeNode
                    key={-1}
                    value={String(-1)}
                    className="tree-node-user"
                    title={
                      <span>
                        <img src={userImg} className="tree-node-icon"/>
                        <span className="tree-node-text">
                          {videoModal ? '外部联系人' : '外部参会人'}
                        </span>
                      </span>
                    }
                  />
                  <TreeNode
                    key={-3}
                    value={String(-3)}
                    className="tree-node-user"
                    title={
                      <span>
                        <img src={userImg} className="tree-node-icon"/>
                        <span className="tree-node-text">本地用户</span>
                      </span>
                    }
                  />
                  {!_.isEmpty(allDeptData)
                    ? this.recursionDept([allDeptData])
                    : []}
                </Tree>
              </div>
              <div className="attend-select-person">
                <ul
                  id="attend-select-person-ul"
                  onScroll={e => {
                    let scrollHeight = document.getElementById("attend-select-person-ul").scrollHeight;
                    let clientHeight = document.getElementById("attend-select-person-ul").clientHeight;
                    let scrollTop = document.getElementById("attend-select-person-ul").scrollTop;
                    if (Math.ceil(clientHeight + scrollTop) >= scrollHeight && userByDept) {
                      const {page, rows = [], records} = userByDept;
                      let currentPage = userByDept && page ? page : this.state.pageCurrent;
                      if (rows.length < records) {
                        if (!this.isSearchValueEmpty(searchValue)) {
                          const {textValue = "", positionValue = ""} = searchValue;
                          let payload = {
                            term: textValue,
                            position: positionValue,
                            page: currentPage + 1,
                            rows: pageSize
                          };
                          dispatch({type: 'meeting/findUsersBySearch', payload: payload});
                        } else {
                          let payload = {nodeCode: selectedNode, page: currentPage + 1, rows: pageSize};
                          dispatch({type: 'meeting/findUsersByDept', payload: payload});
                        }
                        this.setState({pageCurrent: currentPage + 1});
                      }
                    }
                  }}
                >
                  {userByDept &&
                  userByDept.rows &&
                  userByDept.rows.map(user => {
                    let index = -1;
                    selectedList.map((item, i) => {
                      if (String(item.userId) === String(user.userId))
                        index = i;
                    });
                    let isAttendee =
                      index >= 0
                        ? intl.formatMessage({id: 'main_meeting_attend'})
                        : '';
                    let isHolder =
                      holder.userId === String(user.userId)
                        ? intl.formatMessage({id: 'main_meeting_holder'})
                        : '';
                    let img = uncheckedImg;
                    if (!_.isEmpty(isAttendee) || !_.isEmpty(isHolder))
                      img = checkedImg;
                    return (
                      <li key={user.id} className="right-user-item">
                        <div className="align-item">
                          <img
                            src={img}
                            onClick={() => {
                              if (
                                (attendModal && !_.isEmpty(isHolder)) ||
                                (holderModal && !_.isEmpty(isAttendee))
                              ) {
                                Modal.warning({
                                  content: intl.formatMessage({
                                    id: 'attend_holder_conflict'
                                  }),
                                  okText: '确认'
                                });
                                return;
                              }
                              if (holderModal) {
                                if (holder.userId === user.userId) {
                                  this.setState({holder: {}});
                                  return;
                                }
                                if (user.id == user.userId) {
                                  Modal.warning({
                                    content: '申请人不能为外部参会人！',
                                    zIndex: '100000'
                                  });
                                  return;
                                }
                                this.setState({
                                  holder: {
                                    userId: user.userId,
                                    userName: user.firstName +
                                    (this.locale === ENGLISH ? ' ' : '') +
                                    user.givenName,
                                    dept: user.dept,
                                    position: user.position,
                                    mobile:  (user.telAreaCode || '') + user.mobile,
                                    email: user.email,
                                    selectType: 0,
                                    content: user.email + 'undefined',
                                    invite: false,
                                    telAreaCode: user.telAreaCode || '',
                                  }
                                });
                              } else {
                                let userList = _.cloneDeep(selectedList);
                                if (index >= 0) {
                                  userList.splice(index, 1);
                                } else {
                                  userList.push({
                                    userId: user.userId,
                                    userName: user.firstName +
                                    (this.locale === ENGLISH ? ' ' : '') +
                                    user.givenName,
                                    dept: user.dept,
                                    position: user.position,
                                    mobile:  (user.telAreaCode || '') + user.mobile,
                                    email: user.email,
                                    selectType: user.id == user.userId ? 1 : 0,
                                    content: user.email + 'undefined',
                                    invite: false,
                                    telAreaCode: user.telAreaCode
                                  });
                                }
                                if (this.upperLimit(userList)) {
                                  this.setState({selectedList: userList});
                                  this.isAllChecked(
                                    userByDept.rows,
                                    userList
                                  );
                                }
                              }
                            }}
                          />
                          <span className="select-person-span">
                              {`${user.firstName} ${user.givenName} `}
                            {this.getUserDesc(user)}
                            {attendModal && `${!_.isEmpty(isHolder) ? '(' + isHolder + ')' : ''}`}
                            {holderModal && `${!_.isEmpty(isAttendee) ? '(' + isAttendee + ')' : ''}`}
                            </span>
                        </div>
                        {user.id == user.userId ? (
                          <div className="select-person-operate">
                            <div
                              className="iconfont icon-iconfontpencil"
                              onClick={e => {
                                e.stopPropagation();
                                this.setState({
                                  showModal: true,
                                  tempUser: {
                                    id: user.id,
                                    userName: user.displayName,
                                    company: user.company || '',
                                    mobile: user.mobile,
                                    email: user.email,
                                    telAreaCode: user.telAreaCode
                                  }
                                });
                              }}
                            />
                            <Popconfirm
                              placement="topRight"
                              className="user-delete-confirm"
                              title={intl.formatMessage(
                                {id: 'attend_delete_user'},
                                {value: user.displayName}
                              )}
                              onConfirm={e => {
                                e.stopPropagation();
                                const promise = new Promise(
                                  (resolve, reject) => {
                                    dispatch({
                                      type: 'meetingInfo/deleteExternalUser',
                                      payload: user,
                                      resolve,
                                      reject
                                    });
                                  }
                                );
                                promise.then(
                                  data => {
                                    if (
                                      !this.isSearchValueEmpty(searchValue)
                                    ) {
                                      const {
                                        textValue = '',
                                        positionValue = ''
                                      } = searchValue;
                                      let payload = {
                                        term: textValue,
                                        position: positionValue,
                                        page: 1,
                                        rows: pageSize
                                      };
                                      dispatch({
                                        type: 'meeting/findUsersBySearch',
                                        payload: payload
                                      });
                                    } else {
                                      let payload = {
                                        nodeCode: selectedNode,
                                        page: 1,
                                        rows: pageSize
                                      };
                                      dispatch({
                                        type: 'meeting/findUsersByDept',
                                        payload: payload
                                      });
                                    }
                                    this.setState({pageCurrent: 1});
                                  },
                                  msg => {
                                  }
                                );
                              }}
                              okText="是"
                              cancelText="否"
                            >
                              <div className="iconfont icon-lajitong"/>
                            </Popconfirm>
                          </div>
                        ) : null}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="attend-select-pagination">
              <div className="select-pagination-left">
                {attendModal || videoModal ? (
                  <Popover
                    placement="topLeft"
                    trigger="click"
                    visible={this.state.showModal}
                    title={
                      <div className="attend-add-pop">
                        <span>
                          {this.state.tempUser.id
                            ? intl.formatMessage({id: 'edit_external'})
                            : intl.formatMessage({id: 'add_external'})}
                        </span>
                        <span
                          className="ant-modal-close-x"
                          onClick={e => {
                            this.setState({showModal: false});
                          }}
                        />
                      </div>
                    }
                    content={
                      <div className="attend-add-content">
                        <div className="pop-center">
                          <Input
                            className="attend-item"
                            maxLength={'30'}
                            placeholder={intl.formatMessage({
                              id: 'index_username'
                            })}
                            value={this.state.tempUser.userName}
                            onChange={e => {
                              this.setState({
                                tempUser: {
                                  ...this.state.tempUser,
                                  ...{userName: e.target.value}
                                }
                              });
                            }}
                          />
                          <i className="required-flag">*</i>
                          <Input
                            className="attend-item"
                            maxLength={'30'}
                            placeholder={intl.formatMessage({
                              id: 'user_company'
                            })}
                            value={this.state.tempUser.company}
                            onChange={e => {
                              this.setState({
                                tempUser: {
                                  ...this.state.tempUser,
                                  ...{company: e.target.value}
                                }
                              });
                            }}
                          />
                          <div style={{display:"flex",width:"96%"}} className="attend_mobile_div">
                            <Select value={this.state.tempUser.telAreaCode} style={{width: 152}} onChange={value=>{
                              this.setState({
                                tempUser: {
                                  ...this.state.tempUser,
                                  ...{telAreaCode: value}
                                }
                              });
                            }}>
                              <Option value="+86" title="+86">{intl.formatMessage({id: 'country_china'})}</Option>
                              <Option value="+852" title="+852">{intl.formatMessage({id: 'country_china_hk'})}</Option>
                            </Select>
                            <Input
                              className="attend-item"
                              maxLength={'30'}
                              placeholder={intl.formatMessage({
                                id: 'index_phone'
                              })}
                              value={this.state.tempUser.mobile}
                              onChange={e => {
                                this.setState({
                                  tempUser: {
                                    ...this.state.tempUser,
                                    ...{mobile: e.target.value}
                                  }
                                });
                              }}
                            />
                          </div>

                          <Input
                            className="attend-item"
                            maxLength={'30'}
                            placeholder={intl.formatMessage({
                              id: 'index_email'
                            })}
                            value={this.state.tempUser.email}
                            onChange={e => {
                              this.setState({
                                tempUser: {
                                  ...this.state.tempUser,
                                  ...{email: e.target.value}
                                }
                              });
                            }}
                          />
                          <i className="required-flag">*</i>
                        </div>
                        <div className="pop-footer">
                          <Button
                            disabled={!this.state.btnAble}
                            type="primary"
                            onClick={e => {
                              this.setState({btnAble: false});
                              const user = this.state.tempUser;
                              if (user.userName && user.email && user.telAreaCode) {
                                const promise = new Promise(
                                  (resolve, reject) => {
                                    dispatch({
                                      type: 'meetingInfo/saveExternalUser',
                                      payload: user,
                                      resolve,
                                      reject
                                    });
                                  }
                                );
                                promise.then(
                                  data => {
                                    let selectUsers = this.state.selectedList;
                                    if (user.id) {
                                      //更新用户
                                      user.userId = user.id;
                                      user.selectType = 1;
                                      selectUsers.forEach(u => {
                                        if (u.userId == user.userId) {
                                          u.userName = user.userName;
                                          u.dept = user.dept;
                                          u.position = user.position;
                                          u.mobile = user.mobile;
                                          u.email = user.email;
                                          u.telAreaCode = user.telAreaCode;
                                        }
                                      });
                                      if (
                                        !this.isSearchValueEmpty(searchValue)
                                      ) {
                                        const {
                                          textValue = '',
                                          positionValue = ''
                                        } = searchValue;
                                        let payload = {
                                          term: textValue,
                                          position: positionValue,
                                          page: 1,
                                          rows: pageSize
                                        };
                                        dispatch({
                                          type: 'meeting/findUsersBySearch',
                                          payload: payload
                                        });
                                      } else {
                                        let payload = {
                                          nodeCode: selectedNode,
                                          page: 1,
                                          rows: pageSize
                                        };
                                        dispatch({
                                          type: 'meeting/findUsersByDept',
                                          payload: payload
                                        });
                                      }
                                      this.setState({
                                        btnAble: true,
                                        showModal: false,
                                        selectedList: selectUsers,
                                        pageCurrent: 1
                                      });
                                    } else {
                                      //新增用户
                                      user.id = data.id;
                                      user.userId = data.id;
                                      user.selectType = 1;
                                      user.telAreaCode = data.telAreaCode;
                                      selectUsers.push(user);
                                      if (
                                        !this.isSearchValueEmpty(searchValue)
                                      ) {
                                        const {
                                          textValue = '',
                                          positionValue = ''
                                        } = searchValue;
                                        let payload = {
                                          term: textValue,
                                          position: positionValue,
                                          page: 1,
                                          rows: pageSize
                                        };
                                        dispatch({
                                          type: 'meeting/findUsersBySearch',
                                          payload: payload
                                        });
                                      } else {
                                        let payload = {
                                          nodeCode: selectedNode,
                                          page: 1,
                                          rows: pageSize
                                        };
                                        dispatch({
                                          type: 'meeting/findUsersByDept',
                                          payload: payload
                                        });
                                      }
                                      this.setState({
                                        btnAble: true,
                                        showModal: false,
                                        selectedList: selectUsers,
                                        pageCurrent: 1
                                      });
                                    }
                                  },
                                  msg => {
                                    this.setState({btnAble: true});
                                    Modal.error({
                                      content: msg,
                                      zIndex: '100000'
                                    });
                                  }
                                );
                              } else {
                                this.setState({btnAble: true});
                                Modal.warning({
                                  content: intl.formatMessage({
                                    id: 'imcomplete_external_info'
                                  }),
                                  zIndex: '100000',
                                  okText: '确认'
                                });
                              }
                            }}
                          >
                            {intl.formatMessage({id: 'dialog_btn_ok'})}
                          </Button>
                        </div>
                      </div>
                    }
                  >
                    <div
                      id="user-attend-modal-target"
                      className="add-font btn-primary-add"
                      onClick={e => {
                        this.setState({showModal: true, tempUser: {telAreaCode:"+86"}});
                      }}
                    >
                      <i className="iconfont ">+</i>
                      <span className="add-span">
                        {intl.formatMessage({id: 'external_contacts'})}
                      </span>
                    </div>
                  </Popover>
                ) : null}
              </div>
              <div className="select-pagination-right">
                {(attendModal || videoModal) &&
                userByDept &&
                userByDept.rows &&
                userByDept.rows.length > 0 ? (
                  <div className="attend-select-all">
                    <img
                      src={allChecked ? checkedImg : uncheckedImg}
                      onClick={() => {
                        let checked = !allChecked;
                        let allList = _.cloneDeep(selectedList);
                        userByDept &&
                        userByDept.rows &&
                        userByDept.rows.map(user => {
                          // const index = allList.findIndex(item => String(item.userId) === String(user.userId));
                          let index = -1;
                          allList.map((item, i) => {
                            if (String(item.userId) === String(user.userId))
                              index = i;
                          });
                          if (
                            index < 0 &&
                            checked &&
                            user.userId !== holder.userId
                          ) {
                            allList.push({
                              userId: user.userId,
                              userName: user.firstName +
                              (this.locale === ENGLISH ? ' ' : '') +
                              user.givenName,
                              dept: user.dept,
                              position: user.position,
                              mobile: user.mobile,
                              email: user.email,
                              selectType: String(user.id) == user.userId ? 1 : 0,
                              content: user.email + 'undefined'
                            });
                          } else if (
                            index >= 0 && !checked &&
                            user.userId !== holder.userId
                          ) {
                            allList.splice(index, 1);
                          }
                        });
                        if (this.upperLimit(allList)) {
                          this.setState({
                            selectedList: allList,
                            allChecked: checked
                          });
                        }
                      }}
                    />
                    <span>{intl.formatMessage({id: 'all'})}</span>
                  </div>
                ) : (
                  <div />
                )}
              </div>
            </div>
            {holderModal && (
              <div className="attend-select-amount">
                {intl.formatMessage(
                  {id: 'attend_select_amount'},
                  {value: !_.isEmpty(holder.userId) ? 1 : 0}
                )}
              </div>
            )}
            {(attendModal || videoModal) && (
              <div className="attend-select-amount">
                {intl.formatMessage(
                  {id: 'attend_select_amount'},
                  {value: selectedList.length}
                )}
              </div>
            )}
            <div className="attend-select-persons">
              <Table
                rowKey={record => record.userId}
                dataSource={tableData}
                columns={columns}
                pagination={{pageSize: 4}}
              />
            </div>
            <div className="attend-select-button">
              <button
                className="btn-primary"
                onClick={() => this.saveMembers(modalType)}
              >
                {intl.formatMessage({id: 'dialog_btn_ok'})}
              </button>
              <button className="btn-ghost" onClick={() => this.cancelSubmit()}>
                {intl.formatMessage({id: 'dialog_btn_cancel'})}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getUserDesc = user => {
    const {searchValue} = this.state;
    if (searchValue.textValue) {//搜索用户
      if (user.id == user.userId) {//外部参会人，话说，这种区分内部参会人和外部参会人的方法真的好么……
        if (user.email) {
          return `(${user.email}) `
        } else if (user.mobile) {
          return `(${user.mobile}) `
        }
      } else {//内部参会人
        if (user.dept) {
          return `(${user.dept}) `
        } else if (user.position) {
          return `(${user.position}) `
        }
      }
    }
    return "";
  };

  isSearchValueEmpty = (searchValue) => {
    if (searchValue.textValue) {
      return false;
    }
    if (searchValue.positionValue) {
      return false;
    }
    return true;
  };

  recursionDept = deptList => {
    let treeHtml = [];
    deptList &&
    deptList.map(dept => {
      if (dept.depts && dept.depts.length > 0) {
        treeHtml.push(
          <TreeNode
            key={dept.nodeCode}
            value={String(dept.nodeCode)}
            defaultSelectedKeys="0"
            obj={dept}
            title={dept.name}
            className="tree-node-item"
          >
            {this.recursionDept(dept.depts)}
          </TreeNode>
        );
      } else {
        treeHtml.push(
          <TreeNode
            key={dept.nodeCode}
            value={String(dept.nodeCode)}
            defaultSelectedKeys="0"
            obj={dept}
            title={dept.name}
          />
        );
      }
    });
    return treeHtml;
  };

  //把已选的参会人重新编排后，缓存到当前页面
  constructSelectedList = selected => {
    let selectedList = [];
    selected.map(userObj => {
      selectedList.push(userObj);
    });
    this.setState({selectedList: selectedList});
    this.props.userByDept &&
    this.isAllChecked(this.props.userByDept.rows, selectedList);
  };

  constructHolder = holder => {
    if (holder && holder.length > 0) {
      this.setState({holder: holder[0]});
    }
  };

  // 判断是否全选
  getAllCheckedState = (rows, selectedList) => {
    if (rows) {
      let list = _.cloneDeep(selectedList);
      list.push(this.state.holder);
      let exist = true;
      rows.map(user => {
        if (!list.some(item => String(item.userId) === String(user.userId)))
          exist = false;
      });
      return exist;
    }
    return false;
  };

  //判断全选按钮是否勾选
  isAllChecked = (rows, selectedList) => {
    if (rows) {
      let list = _.cloneDeep(selectedList);
      list.push(this.state.holder);
      let exist = true;
      rows.map(user => {
        if (!list.some(item => String(item.userId) === String(user.userId)))
          exist = false;
      });
      this.setState({allChecked: exist});
    }
  };

  //判断参会人数是否超过会议室人数上限
  upperLimit = selectedList => {
    return true;
  };

  saveMembers = modalType => {
    const {onChange, changeHolder, changePublicUser} = this.props;
    let list = [];
    if (modalType === HOLDER_MODAL && this.state.holder) {
      if (typeof changeHolder === 'function') {
        if (!_.isEmpty(this.state.holder)) {
          list.push(this.state.holder);
        }
        changeHolder(list);
      }
    } else if (modalType === ATTEND_MODAL) {
      if (typeof onChange === 'function') {
        this.state.selectedList.map(user => {
          list.push(user);
        });
        onChange(list);
      }
    } else if (modalType === VIDEO_PUBLIC_MODAL) {
      if (typeof changePublicUser === 'function') {
        this.state.selectedList.map(user => {
          list.push(user);
        });
        changePublicUser(list);
      }
    }
    this.closeModal();
  };

  cancelSubmit = () => {
    let selectedList = [];
    this.props.selected.map(userObj => {
      selectedList.push(userObj);
    });
    this.setState({selectedList: selectedList});
    if (this.props.holder && this.props.holder.length > 0) {
      this.setState({holder: this.props.holder[0]});
    }
    this.closeModal();
  };

  closeModal = () => {
    const {openModal} = this.props;
    if (typeof openModal === 'function') openModal(false);
    this.setState({allChecked: false, searchValue: {}});
  };
}

export default connect(state => ({...state}))(UserSelect);



// WEBPACK FOOTER //
// ./src/components/meeting/UserSelect.js